import { Note } from "../../../../../components/primitives/data-display/Note";
import { DocumentScopeField } from "../../DocumentScopeField";
import type { UseAdmissionRecheckParamsResult } from "./useAdmissionRecheckParams";

export interface AdmissionRecheckParamsFormProps {
  form: UseAdmissionRecheckParamsResult;
}

/** The params an admission_recheck job asks for: which documents to re-check. */
export function AdmissionRecheckParamsForm({ form }: AdmissionRecheckParamsFormProps) {
  return (
    <>
      <DocumentScopeField form={form} />
      <Note>
        Nothing is revoked automatically — every rejection or escalation this job finds waits for
        human review before any document leaves the corpus.
      </Note>
    </>
  );
}
